<template>
  <div v-if="!loading">
    <h1 class="title font-weight-regular">
      Prehľad zmien IAPSZ:
    </h1>
    <v-data-iterator
      :items="prehlad_zmien"
      hide-default-footer
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="(item, index) in props.items"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">
                {{
                  item.date
                }}
              </v-card-title>

              <v-divider />

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <strong>Používateľ:</strong>
                  </v-list-item-content>
                  <v-list-item-content class="align-end">
                    <strong>{{ item.user }}</strong>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <strong>Časť:</strong>
                  </v-list-item-content>
                  <v-list-item-content class="align-end">
                    <strong>{{ item.model }}</strong>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-for="(field, index2) in item.fields"
                  :key="index2"
                >
                  <v-list-item-content>{{ field.name }}:</v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                  >
                    {{ field.old }} -> {{ field.new }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>

  <div v-else>
    <form-skeleton-component
      skeleton_type="PrehladZmien"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import FormSkeleton from "../components/FormSkeleton.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,

    prehlad_zmien: [],
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    getItem() {
      this.loading = true;
      apiService
        .getIapszPrehladZmien(this.$route.params.id)
        .then((response) => {
          this.prehlad_zmien = response;
          this.loading = false;
        });
    },
  },
};
</script>